import { PlatformLocation } from '@angular/common';
import { Component, EventEmitter, OnInit, Output, Input } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { Observable, Subject } from 'rxjs';
import { HttpService } from 'src/services/http.service';
import { CustomValidators } from 'src/validators';
import * as STATES from 'src/assets/states.json';
import { debounceTime, map } from 'rxjs/operators';
import { ViaCepService } from 'src/services/via-cep.service';
import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import * as accents from 'remove-accents';
import { CnpjService } from 'src/services/cnpj.service';

@Component({
  selector: 'app-step-company-basic-info',
  templateUrl: './step-company-basic-info.component.html',
  styleUrls: ['./step-company-basic-info.component.scss']
})
export class StepCompanyBasicInfoComponent implements OnInit {

  form: FormGroup;
  @Output() submited: EventEmitter<boolean>;
  @Output() hiddenCheckout: EventEmitter<boolean>;
  @Output() formObserver: Subject<FormGroup>;
  @Input() initData: EventEmitter<any>;
  mauticFormSrc: any = null;
  states: Array<any> = (STATES as any).default;
  cities$: Observable<any>;
  filteredStates$: Observable<any>;
  filteredCities$: Observable<any>;
  cities: Array<any> = [];

  constructor(
    fb: FormBuilder,
    private sanitazer: DomSanitizer,
    private pLocation: PlatformLocation,
    private http: HttpService,
    private route: ActivatedRoute,
    private viaCep: ViaCepService,
    private cnpj: CnpjService
  ) {

    this.form = fb.group({
      businessName: [null, Validators.required],
      companyName: [null, Validators.required],
      cnpj: [null, [Validators.required, CustomValidators.cnpj]],
      ie: [null],
      im: [null],
      taxRegime: [null, Validators.required],
      zipCode: [null, Validators.required],
      state: [null, Validators.required],
      city: [null, Validators.required],
      street: [null, Validators.required],
      district: [null, Validators.required],
      number: [null, Validators.required],
      complement: [null],
      email: [null, [Validators.required, Validators.email]],
      phone: [null, [Validators.required, CustomValidators.phone]],
      uf: [null],
      stateName: [null]
    })
    this.submited = new EventEmitter<any>();
    this.hiddenCheckout = new EventEmitter<any>();
    this.formObserver = new Subject<FormGroup>();

    this.route.queryParams
      .subscribe(
        query => {
          if (query.email)
            this.form.get('email').setValue(query.email);
        }
      )

  }

  ngOnInit(): void {

    this.formObserver.next(this.form)
    this.form.get('zipCode')
      .valueChanges
      .pipe(debounceTime(500))
      .subscribe(
        cep => {
          if (!this.form.get('zipCode').invalid) {
            this.viaCep.getLocation(cep)
              .subscribe(
                data => {

                  const { bairro, localidade, logradouro, uf } = data;
                  if (!data.erro) {
                    const state = this.states.find(state => state
                      ? state.sigla.toLowerCase() ===
                      uf.toLowerCase() : null);

                    this.form.patchValue({
                      district: bairro,
                      city: localidade,
                      street: logradouro,
                      state: state,
                      uf: uf,
                      stateName: state ? accents.remove(state.nome) : null
                    })

                  } else {
                    alert('CEP inválido por favor tente novamente');
                    this.form.patchValue({
                      zipCode: ''
                    });
                  }
                }
              )
          }
        }
      )

    this.filteredStates$ = this.form.get('state')
      .valueChanges
      .pipe(
        map(state => this._filterStates(state))
      );

    this.filteredCities$ = this.form.get('city')
      .valueChanges
      .pipe(map(city => this._filterCities(city)));

  }

  ngAfterViewInit() {

    this.form.get('cnpj')
      .valueChanges
      .subscribe(
        (cnpj: string) => {

          if (this.form.get('cnpj').valid) {
            const subject = new Subject<any>();
            subject.subscribe({
              next: (result: any) => {
                if (result && result.Status == 'paid')
                  this.hiddenCheckout.emit(true);
                else this.hiddenCheckout.emit(false);
              }
            })

            //this.cnpj.searchCnpj(cnpj, subject);
          } else this.hiddenCheckout.emit(false);

        }
      )

    if (this.initData)
      this.initData.subscribe((data) => {

        this.form.patchValue(
          {
            businessName: data['user'].company,
            companyName: data['company'].companyname,
            cnpj: data['company'].cnpj,
            taxRegime: data['company'].tax_regime,
            zipCode: data['company'].companyzipcode,
            city: data['company'].companycity,
            street: data['company'].companyaddress1,
            district: data['company'].district,
            number: data['company'].companyaddress2,
            email: data['company'].companyemail
          },
          { emitEvent: false }
        );

      })
  }

  onSubmit(): void {

    if (!this.form.invalid) {
      const data = this.form.getRawValue();

      localStorage.setItem('email', data.email)
      const params = new URLSearchParams();
      for (let key in data) {
        const value = data[key];
        if (value)
          params.append(key, value);
      }
      const bHref = this.pLocation.getBaseHrefFromDOM();
      this.mauticFormSrc = this.sanitazer
        .bypassSecurityTrustResourceUrl(`${bHref}mautic-form/step-company-basic-info?${params.toString()}`);

      this.submited.emit();
    }

  }

  public displayState(state: any): string {
    return state ? state.sigla : '';
  }

  public onStateSelected(args: MatAutocompleteSelectedEvent) {

    const { option: { value } } = args;

    this.http.list('city', { initials: value.sigla })
      .subscribe(
        (cities: any) => {
          this.cities = cities;
        }
      );

  }

  private _filterCities(city) {
    city = city.toLowerCase();
    return this.cities.filter(_city => _city.name.toLowerCase().indexOf(city) > -1);
  }

  private _filterStates(state) {

    if (typeof state !== 'string') return;

    let name = accents.remove(state.toLowerCase());
    return this.states.filter(_state => accents.remove(_state.nome).toLowerCase().indexOf(name) > -1
      || _state.sigla.toLowerCase().indexOf(name) > -1);

  }

}
